<template>
  <div class="home">
    <br>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  components: {

  },
}
</script>
<style>
  div.home {
    text-align:center;
    background-image: url("/images/banner.jpg");
    background-repeat:no-repeat;
    background-size: cover;
    width:100%;
    height:calc(100vh - 120px);
  }
</style>